import React, { useEffect, useRef, useState } from "react"
import { DialogInput } from "screens/components/advanced";
import Button from "screens/components/basic/Button";
import DialogHeaderWithClose from "screens/components/basic/DialogHeaderWithClose";
import { useParams } from "react-router-dom";
import DeleteIcon from '@mui/icons-material/Delete';
import 'react-image-crop/dist/ReactCrop.css'
import { deleteProductImageAction, getProduct, getProductInfoAction, postNewProductImageAction } from "actions/EntityActions";
import { useDispatch, useSelector } from "react-redux";
import "../Styles/style.scss"
import SelectImageWithCrop from "../../../../components/advanced/SelectImageWithCrop";
import CustomValueHook from "screens/components/advanced/customValueHook";


const MultipleImageUpload = () => {
  const uploadSuccess = useSelector(state => state.entity.imagUploadingSuccess)
  const uploadPending = useSelector(state => state.entity.imagUploadingPending)
  const deleteSuccess = useSelector(state => state.entity.deleteImageSuccess)



  const branchId = useSelector(state => state.common.branchId)
  const productInfo = useSelector(state => state.entity.productInfoResult)
  const params = useParams();
  const [state, setState] = CustomValueHook({ displayModal: false, displayDeleteConfirmModal: false })
  const dispatch = useDispatch()

  useEffect(()=>{
    if (state.displayModal) {
      dispatch(getProductInfoAction(params.id))
    }
    
  },[state.displayModal])

  useEffect(() => {
    if (uploadSuccess) {
      dispatch(getProductInfoAction(params.id))
    }
  }, [uploadSuccess])
  useEffect(() => {

    if (productInfo) {
      setState({ imageList: JSON.parse(productInfo.imageList) })
    } else {
      setState({ imageList: null })

    }
  }, [productInfo])

  useEffect(() => {
    if (deleteSuccess) {
      setState({ displayDeleteConfirmModal: false, selectedImage: null })
      dispatch(getProductInfoAction(params.id))

    }
  }, [deleteSuccess])

  const handleUploadImage = async (imageBase64) => {

    dispatch(postNewProductImageAction({ ID: params.id, URLImage: imageBase64 }));
  }
  const handleRemove = () => {
    dispatch(deleteProductImageAction({ ImageID: state.selectedImage.ImageID, ID: params.id }))
  }
  return (
    <div>
      <Button name="RaisedButton"
        className="pull-left"
        primary={true}
        onTouchTap={() => setState({ displayModal: true })}
        label="Upload multiple images" />

      <DialogInput
        title={<DialogHeaderWithClose text={"Upload product image"} classicClass="posDialogClassic" handleClose={() => setState({ displayModal: false })} />}
        className="no_btns_dialog"
        modal={true}
        open={state.displayModal}
        autoScrollBodyContent={true}
        style={{ minWidth: "70% !important" }}
      >
        <div>
          <div>
            <div className="row" >
              <div className="col-md-7" >
                <div className="product-image-modal-big-image-context" >
                  {!state.croppedImage ? <div>
                    {state.selectedImage ? <img src={state.selectedImage.ImageUrl} /> : <div className="no-image-selected-context" ><h3>Not Image Selected</h3></div>}
                    {state.selectedImage && <span onClick={() => setState({ displayDeleteConfirmModal: true })}><DeleteIcon /></span>}
                  </div> : <div><img src={state.croppedImage} /></div>}
                </div>
                <div className="sm-images-context" >
                  <fieldset>
                    <legend>Uploaded Images</legend>
                    <div className="scroll-context" >
                      {state.imageList && state.imageList && state.imageList.map((img, idx) =>
                        <div className="image-item" key={idx} onClick={() => setState({ selectedImage: img })}>

                          <img src={img.ImageUrl} />
                        </div>)}
                    </div>

                  </fieldset>
                </div>

              </div>
              <div className="col-md-5" >
                <SelectImageWithCrop
                  handleUpload={handleUploadImage}
                  uploadPending={uploadPending}
                  uploadSuccess={uploadSuccess}
                />
              </div>
            </div>
          </div>
        </div>
      </DialogInput>

      <DialogInput
        title={<DialogHeaderWithClose text={"Upload product image"} classicClass="posDialogClassic" handleClose={() => setState({ displayDeleteConfirmModal: false })} />}
        className="no_btns_dialog"
        modal={true}
        open={state.displayDeleteConfirmModal}
        autoScrollBodyContent={true}
        style={{ minWidth: "30% !important" }}
      >
        <div>
          <p>Are you sure you want to delete the image?</p>
        </div>
        <div>
          <Button
            className=" mr-2"
            type="IconInButton"
            label={"Confirm"}
            onTouchTap={handleRemove} />
          <Button
            type="IconInButton"
            className="bg-light-green"
            label={"Cancel"}
            dispatch={uploadPending}
            onTouchTap={() => setState({ displayDeleteConfirmModal: false })} />
        </div>
      </DialogInput>
    </div>
  )
}


export default MultipleImageUpload
